import { Card } from '@plato/ui-legacy/components/ui/card';
import { CollapsibleContainer } from '@plato/ui-legacy/components/ui/collapsible-container';
import { CollapsibleText } from '@plato/ui-legacy/components/ui/collapsible-text';
import { useTranslation } from 'react-i18next';
import type { RouterOutput } from '../../../server/types/infer-trpc-types.ts';
import { RichTextViewer } from '../../rich-text/components/rich-text-viewer.tsx';

type Props = {
    data: RouterOutput['platoUser']['getDetailProduct']['getProductDetail'];
};

export function InventoryDetailsDescription({ data: data }: Props) {
    const { t } = useTranslation();

    // Use the backend-provided combined and sanitized description
    if (!data.description) {
        return null;
    }

    return (
        <CollapsibleContainer defaultOpen title={t('description', { ns: 'product-details' })}>
            <Card>
                <CollapsibleText canOpen>
                    <RichTextViewer content={data.description} />
                </CollapsibleText>
            </Card>
        </CollapsibleContainer>
    );
}
